const Query = require( 'helper/query' );

const self = {
  urls: {
    todayBid: '/front/search/today-bid', // 青海今日开标
    searchCategory: '/front/search/category', // 搜索二级页文章分类
    searchAll: '/front/search/all', // 搜索全站
    addClickApi: '/visitor/add-clicks',
    agencyBaseInfo: '/api/core/remote/agentDetail',
    agencyList: '/api/core/remote/agentList',
    esSearch: '/es-articles/es-article/_search',
    esSearchOfMail: '/letters/letter/_search',
    sendLetterInfo: '/api/core/letter/create',
    letterDetail: '/letters/letter/', // 获取青海公开信箱详情接口
    supplierList: '/api/core/remote/supplierList',
    supplierBaseInfo: '/api/core/remote/supplierDetail',
    supplierCompany: '/api/core/remote/supplierCompany',
    supplierLegalPerson: '/api/core/remote/supplierLegal',
    supplierCertificates: '/api/core/remote/supplierCertificates',
    agencyCount: '/api/core/remote/agencyIndexCount', // 政采云代理机构数量统计
    homeAgencyList: '/api/core/remote/agencyIndexList', // 政采云注册代理机构列表
    expertCount: '/api/core/remote/expertIndexCount', // 政采云采购评审专家数量
    supplierCount: '/api/core/remote/supplierIndexCount', // 政采云注册供应商数量
    officialSupplierIndexInfo: '/api/core/remote/officialSupplierIndexInfo', // 政采云正式注册供应商列表
    publicSupplierIndexInfo: '/api/core/remote/publicSupplierIndexInfo', // 政采云公示中注册供应商列表
    img: '/api/core/captcha', // 验证码获取
    getDepart: '/api/core/departments', // 写信弹窗机构获取
    catalog: '/api/core/remote/getSpecialYearGpcatalog', // 采购目录
    getProductList: '/api/core/remote/getNodeMapList',
    districtList: '/api/core/remote/districtList', // 区划树(一次只返回一级)
    listHall: '/api/core/remote/listhall', // 在线询价接口
    reverseListHall: '/api/core/remote/reverseListhall', // 反向竞价接口
    districtTree: '/api/core/remote/tenantsTree', // 区划树(可根据参数决定返回树的级数)
    announcementDistrict: '/api/core/remote/announcementDistrict', // 公告区划树(可根据参数决定返回树的级数)
    procurementMenuMode: '/api/core/purchase-method-codes', // 采购目录
    activityList: '/business/front/activity/list', // 活动列表
    // activityDetail: '/business/activity/front/detail', // 活动详情
    activityDetail: '/business/front/activity/detail', // 活动详情
    redBlackHomeList: ' /business/front/red-black/home-list', // 首页红黑榜单
    redBlackCategory: '/business/front/red-black/category', // 红黑榜分类树
    redBlackList: '/business/front/red-black/paging', // 红黑榜单列表
    redBlackDetail: '/business/front/red-black/detail', // 红黑榜详情（含首页列表）
    memberDetail: '/business/front/member/detail',
    passwordModify: '/business/front/member/password-modify',
    upload: '/admin/file/more/upload', // 上传文件图片接口
    downloadCert: '/business/certificate/fl/download',
    regionList: '/front/search/site/list', // 站点集合列表s
  },
  getRedBlackDetail( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.redBlackDetail,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  getRedBlackList( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.redBlackList,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  getRedBlackCategory( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.redBlackCategory,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  getRedBlackHomeList( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.redBlackHomeList,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  /**
   * 搜索二级页面文章列表
   * @param {*} params
   */
  getTodayBid( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.todayBid,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  /**
   * 搜索二级页面文章列表
   * @param {*} params
   */
  searchCategory( params = {} ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.searchCategory,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  /**
   * 全文搜索服务
   * @param {*} params
   */
  searchAll( params = {} ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.searchAll,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  getActivityDetail( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.activityDetail,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  /**
   * 获取活动列表
   * @param {*} params
   */
  getActivityList( params ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.activityList,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  // 采购目录
  queryProcurementMenuMode( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.procurementMenuMode,
      contentType: 'application/json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  // 网站访问量统计
  visitCount( params = {} ) {
    const query = new Query();
    const PID = query.get( 'PID' );
    if (PID) {
      params.PID = PID;
    }
    return $.ajax( {
      type: 'GET',
      url: this.urls.addClickApi,
      data: params,
      contentType: 'application/json',
      dataType: 'json'
    } );
  },
  // 文章详情预览
  queryArticlePreview( params = {} ) {
    const opts = {
      type: 'GET',
      url: '/article/detail',
      contentType: 'application/json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  // 文章详情
  queryArticleDetail( params = {} ) {
    const opts = {
      type: 'GET',
      url: '/show/content',
      contentType: 'application/json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getAgencyBaseInfo( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.agencyBaseInfo,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getAgentList( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.agencyList,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getSupplierList( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.supplierList,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getSupplierBaseInfo( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.supplierBaseInfo,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getSupplierCompany( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.supplierCompany,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getSupplierLegalPerson( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.supplierLegalPerson,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  getSupplierCertificates( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.supplierCertificates,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  /**
   * 获取采购目录信息
   * @param {*} params
   */
  getCatalog( params = {} ) {
    const opts = {
      type: 'GET',
      url: self.urls.catalog,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  /**
   * 获取采购目录下商品列表
   * @param {*} params
   */
  getProductList( params = {} ) {
    const opts = {
      type: 'GET',
      url: self.urls.getProductList,
      contentType: 'application/json',
      dataType: 'json'
    };
    $.extend( opts, params );
    return $.ajax( opts );
  },
  /**
   *  用es进行搜索
   * @param {*} params
   */
  queryES( params ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.esSearch,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  /**
   *  用es搜索公开信箱列表
   * @param {*} params
   */
  queryMailList( params ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.esSearchOfMail,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },

  // 公开信箱提交信件留言
  sendLetter( params ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.sendLetterInfo,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },

  // 公开信箱详情获取
  getLetterDetail( id ) {
    return $.ajax( {
      type: 'get',
      url: this.urls.letterDetail + id,
      contentType: 'application/json'
    } );
  },

  /**
   * 获取政采云公开接口的数据
   * @param {string} key 接口别名
   */
  getCMSData( key, ajaxOptions ) {
    const opts = {
      type: 'GET',
      url: this.urls[ key ],
      contentType: 'application/json'
    };
    $.extend( opts, ajaxOptions );
    return $.ajax( opts );
  },

  // 获取机构 id
  getDepartments() {
    return $.ajax( {
      url: this.urls.getDepart,
      contentType: 'application/json'
    } );
  },

  // 获取区划信息
  getDistrictList( params = {} ) {
    return $.ajax( {
      url: this.urls.districtList,
      data: params,
      contentType: 'application/json',
      dataType: 'json'
    } );
  },
  // 获取区划树
  getDistrictTree( params = {} ) {
    const _params = {
      queryWithCode: true,
      includeSelf: false,
      includeAllNode: true,
      filterNotActive: true
    };
    $.extend( _params, params );
    return $.ajax( {
      url: self.urls.districtTree,
      data: _params,
      contentType: 'application/json',
      dataType: 'json'
    } ).then( ( res ) => {
      // 将省本级放在第一位
      const { data } = res;
      const arr = [ ...data.filter( item => /9900$/.test( item.code ) ), ...data.filter( item => !/9900$/.test( item.code ) ) ];
      res.data = arr;
      return res;
    } );
  },
  // 获取公告区划树
  getAnnouncementDistrict( params = {} ) {
    const _params = {
      queryWithCode: true,
      includeSelf: false,
      includeAllNode: true,
      filterNotActive: true
    };
    $.extend( _params, params );
    return $.ajax( {
      url: self.urls.announcementDistrict,
      data: _params,
      contentType: 'application/json',
      dataType: 'json'
    } ).then( ( res ) => {
      // 将省本级放在第一位
      const { data } = res;
      const arr = [ ...data.filter( item => /9900$/.test( item.code ) ), ...data.filter( item => !/9900$/.test( item.code ) ) ];
      res.data = arr;
      return res;
    } );
  },
  // 上海
  getSHAnnouncementDistrict( params = {} ) {
    const _params = {
      queryWithCode: true,
      includeSelf: false,
      includeAllNode: true,
      filterNotActive: false
    };
    $.extend( _params, params );
    return $.ajax( {
      url: self.urls.announcementDistrict,
      data: _params,
      contentType: 'application/json',
      dataType: 'json'
    } ).then( ( res ) => {
      // 将省本级放在第一位
      const { data } = res;
      const arr = [ ...data.filter( item => /9900$/.test( item.code ) ), ...data.filter( item => !/9900$/.test( item.code ) ) ];
      res.data = arr;
      return res;
    } );
  },
  // 获取会员详情
  getMemberDetail( params = {} ) {
    const opts = {
      type: 'GET',
      url: this.urls.memberDetail,
      contentType: 'application/json',
      data: params
    };
    return $.ajax( opts );
  },
  commitPasswordModify( params = {} ) {
    return $.ajax( {
      type: 'post',
      url: this.urls.passwordModify,
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  getMemberAtlas( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/photo-list',
      contentType: 'application/json',
      data: params
    } );
  },
  deleteMemberAtlas( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/delete-photo',
      contentType: 'application/json',
      data: params
    } );
  },
  setAsCover( params ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/set-cover',
      contentType: 'application/json',
      data: params
    } );
  },
  addMemberAtlas( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/member/add-photo',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  getMemberFeeList( params ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/fee/list',
      contentType: 'application/json',
      data: params
    } );
  },
  getMemberFeeAttachments( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/fee/detail',
      contentType: 'application/json',
      data: params
    } );
  },
  getMemberFeeDetail( params ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/fee/config/detail',
      contentType: 'application/json',
      data: params
    } );
  },
  getMemberFeeChargeDetail( params ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/member/fee/charge/detail',
      contentType: 'application/json',
      data: params
    } );
  },

  // 会员查看报名详情
  getSignUpDetail( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/sign-up/detail',
      contentType: 'application/json',
      data: params
    } );
  },
  submitPayment( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/sign-up/payment/save',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  showPayment( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/activity/apply/fl/show/payment',
      contentType: 'application/json',
      data: params
    } );
  },
  getPaymentDetail( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/activity/apply/fl/payment/detail',
      contentType: 'application/json',
      data: params
    } );
  },
  getArticleList( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/article/paging',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  getArticleDetail( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/article/detail',
      contentType: 'application/json',
      data: params
    } );
  },

  deleteArticle( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/article/delete',
      contentType: 'application/json',
      data: params
    } );
  },
  getMessageList( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/message/paging',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  getMessageDetail( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/message/detail',
      contentType: 'application/json',
      data: params
    } );
  },
  setMessageReaded( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/message/read',
      contentType: 'application/json',
      data: params
    } );
  },
  getStaffList( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/person/member/persons',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  deleteStaff( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/person/delete',
      contentType: 'application/json',
      data: params
    } );
  },
  saveStaff( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/person/save',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  getInvoice( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/invoice/paging',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  submitMemberFee( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/member/fee/audit/pay',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  querySignUpList( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/sign-up/paging',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  queryMemberListApi( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/member/list',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  purchaseGetLoginUser( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/login/login-info',
      contentType: 'application/json',
      data: params
    } );
  },
  purchaseLogin( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/login/login',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  purchaseLogout( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/login/logout',
      contentType: 'application/json',
      data: params
    } );
  },
  getSignUps( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/sign-up/paging',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  exchangeSignUpStaff( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/sign-up/person/exchange',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  queryCategories( params = {} ) {
    return $.ajax( {
      type: 'POST',
      url: '/business/front/page/categories',
      contentType: 'application/json',
      data: JSON.stringify( params )
    } );
  },
  purchaseHomeMembers( params = [] ) {
    return $.ajax( {
      type: 'GET',
      url: '/business/front/page/members',
      contentType: 'application/json',
      data: params
    } );
  },
  regionListApi( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: this.urls.regionList,
      contentType: 'application/json',
      data: params
    } );
  },
  queryItemClasses( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/api/core/item-classes',
      contentType: 'application/json',
      data: params
    } );
  },
  queryAnnouncementTypes( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/api/core/announcement-types',
      contentType: 'application/json',
      data: params
    } );
  },
  queryFloating( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/front/search/floating/detail',
      contentType: 'application/json',
      data: params
    } );
  },
  querySpecialColumn( params = {} ) {
    return $.ajax( {
      type: 'GET',
      url: '/front/search/special/column/list',
      contentType: 'application/json',
      data: params
    } );
  },
};

module.exports = self;
